import { render, staticRenderFns } from "./mapModal.vue?vue&type=template&id=0b6d5478"
import script from "./mapModal.vue?vue&type=script&lang=js"
export * from "./mapModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports